import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import logoimg from '../Images/litax_footerlogo.png';
import footerlogoimg from '../Images/irs.png';


// Updated icons
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const Footer = () => {
  const emaill = 'info@litaxfilers.com';

  const handleEmailClick = () => {
    window.location.href = `mailto:${emaill}`;
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Logo & About */}
        <div className="footer-section">
          <img src={logoimg} alt="Litax" className="footer-logo" />
          
          <p className="tagline">WE FILE TAX , YOU RELAX</p>
          <img src={footerlogoimg} alt="Litax" className="footer-logo2" />
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/signup">Register Now</Link></li>
            <li><Link to="/refundstatus">Refund Status</Link></li>
            <li><Link to="/refundpolicy">Refund Policy</Link></li>
            <li><Link to="/privacypolicy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3>Our Services</h3>
          <ul>
            <li><Link to="/federal">Federal & State Filing</Link></li>
            <li><Link to="/representation">Tax Representation</Link></li>
            <li><Link to="/itinpreparation">ITIN Preparation</Link></li>
            <li><Link to="/taxplanning">Advanced Tax Planning</Link></li>
            <li><Link to="/fbar">FBAR & FATCA Compliance</Link></li>
            <li><Link to="/amendment">Amendment Filing</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Get in Touch</h3>
        <p>+1 (302) 390-8271</p>
          <p>81 Thorn Lane, Newark, DE 19711</p>
          <p className="email" onClick={handleEmailClick}>{emaill}</p>
          <div className="social-icons">
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaXTwitter /></a> {/* ✅ Replaced with X icon */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 Litax | All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
